import * as bootstrap from 'bootstrap';
( function () {
	'use strict';

	// To init this boostrap needs to be imported but block JS is not part of the webpack bundling process, so it needs to be run from here
	// We're not including block JS into the webpack bundle because it should only be loaded when a block is on a page, if the JS is bundled
	// into the larger main.js it will all be loaded regardless of whether the block is on a given page.
	const testimonialCarouselContainer = document.getElementById('carouselTestimonials');
	if (testimonialCarouselContainer) {
		const testimonialCarousel = new bootstrap.Carousel(testimonialCarouselContainer,  {
			interval: 7000,
			wrap: true,
			ride: 'carousel',
			pause: 'hover',
			touch: true,
			keyboard: true
		});
	}

	const premiumMembersCarouselContainer = document.getElementById('carouselPremiumMembers');
	if (premiumMembersCarouselContainer) {
		const premiumMembersCarousel = new bootstrap.Carousel(premiumMembersCarouselContainer,  {
			interval: 8000,
			wrap: true,
			ride: 'carousel',
			pause: 'hover',
			touch: true,
			keyboard: true
		});
	}

	const logosCarouselMobileContainer = document.getElementById('carouselLogosMobile');
	if (logosCarouselMobileContainer) {
		const generalLogosCarouselContainer = new bootstrap.Carousel(logosCarouselMobileContainer,  {
			interval: 2000,
			wrap: true,
			ride: 'carousel',
			pause: 'hover',
			touch: true,
			keyboard: true
		});
	}

	const logosCarouselContainer = document.getElementById('carouselLogos');
	if (logosCarouselContainer) {
		const generalLogosCarouselContainer = new bootstrap.Carousel(logosCarouselContainer,  {
			interval: 2000,
			wrap: true,
			ride: 'carousel',
			pause: 'hover',
			touch: true,
			keyboard: true
		});
	}

	// Global handling of all tooltips on the site
	let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
	let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
		return new bootstrap.Tooltip(tooltipTriggerEl)
	});

	const dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'))
	const dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
	  return new bootstrap.Dropdown(dropdownToggleEl)
	});

	const setMinHeight = () => {
		const elementsToAdjust = document.querySelectorAll('.set-min-height');
		const footer = document.querySelector('.footer');
		const header = document.querySelector('.site-header');
		const headerHeight = Math.floor(header.getBoundingClientRect().height);
		const footerHeight = Math.floor(footer.getBoundingClientRect().height);
		const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
		const contentBodyMinHeight = viewportHeight - (headerHeight + footerHeight);

		elementsToAdjust.forEach(element => {
			element.style.minHeight = `${contentBodyMinHeight}px`;
		});
	};

	window.addEventListener('resize', (event) => {
		setMinHeight();
	}, true);

	window.onload = (event) => {
		setMinHeight();
	};

} )();
